import {Component, HostListener, OnInit} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {Attachment} from '../../../types/email-data.types';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'view-attachment-modal',
    templateUrl: './view-attachment-modal.component.html',
    styleUrls: ['./view-attachment-modal.component.scss']
})
export class ViewAttachmentModalComponent implements OnInit {
    showModal = false;
    data: Attachment;
    type: string;

    constructor(
        public es: EmailService,
        public urlService: UrlService
    ) {}

    ngOnInit(): void {
        this.data = this.es.attachmentInViewAttachmentModal;

        setTimeout(() => this.showModal = true, 500);
        this.urlService.modalOpened.emit();
    }

    hideModal(): void {
        this.es.isViewAttachmentModalShow = false;
        this.es.attachmentInViewAttachmentModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/email/view-attachment-modal/view-attachment-modal.component.ts